import * as yup from 'yup';

const loginValidationSchema = yup.object().shape({
  username: yup.string().required('Email Address is Required'),
  password: yup.string().required('Password is Required'),
});

export default loginValidationSchema;
